import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    updateChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})       
    }

    

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    
}

export default UpdateBloc